import React, { Component } from 'react'

import { connect } from 'react-redux'

import './modalUploader.css'

import FaUpload from 'react-icons/lib/fa/upload'

class ModalUploader extends Component {

  constructor(props) {
    super(props)
    this.fileName = "myfiles"
    this.url = "https://socket.eldocs.net/api/uploadfiles"
    this.upd = null;
  }

  state = {
    p: '0%',
    uploading: false
  }

  componentDidMount() {

  }

  uploadFinished = (status) => {
    //alert(status)
  }

  clickHandler = (e) => {
    if (this.upd === null) return;
    this.upd.focus()
  }

  changeHandler = (e) => {
    var self = this;
    var files = this.upd.files;
    var formData = new FormData();
    formData.append('owner', this.props.owner)
    formData.append('to', this.props.to)
    formData.append('latestTime', this.props.latestTime)
    for (var file in files) {
      formData.append(this.fileName, files[file]);
    }

    var xhr = new XMLHttpRequest();
    xhr.open('POST', "https://socket.eldocs.net/api/uploadfiles", true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    xhr.onreadystatechange = function () {//Call a function when the state changes.
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        //console.log("finished!")
        self.setState({ uploading: false })
        self.setState({ p: '0%' })
      }
    }

    xhr.upload.onprogress = function (e) {
      if (e.lengthComputable) {
        var percentComplete = (e.loaded / e.total) * 100;
        self.setState({ p: percentComplete.toFixed(1) + '%' })
        //console.log(percentComplete + '% uploaded');
      }
    };
    xhr.onload = function () {
      //console.log("onload")
      //alert("onload: " + xhr.statusText + " " + xhr.responseText)
      //self.uploadFinished(this.status); //status == 200 success
    };
    xhr.onerror = function (е) {
      self.setState({ uploading: false })
      self.setState({ p: '0%' })
      console.error("error: " + xhr.statusText + " " + xhr.responseText)
    }
    xhr.send(formData);
    self.setState({ uploading: true })
  }

  render() {
    return (
      <div onClick={this.clickHandler}>
        <label className="uploadIcon" htmlFor="upd">
          {this.state.uploading ?
            [
              <div key="0" className="loading"></div>,
              <div key="1" className="p">{this.state.p}</div>
            ] :
            <FaUpload />
          }

        </label>

        <input ref={(input) => { this.upd = input; }} multiple
          onChange={this.changeHandler}
          type="file" name={this.fileName}
          id="upd"
          style={{ display: "none" }} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {

  }
}

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(ModalUploader);


// WEBPACK FOOTER //
// ./src/common/chat/modalWindow/modalWindowFooter/modalUploader/modalUploader.js